export const exchangesFormSelector = (state) => {
  const { form } = state;
  return form?.formExchange?.values;
};

export const exchangesSelector = (state) => {
  const { user } = state;
  return user?.exchanges;
};
